import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import Logo from "@/components/Logo";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/schools", label: "Schools" },
  { to: "/parents", label: "Parents" },
  { to: "/vendors", label: "Partners" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export default function PublicNav() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  return (
    <header className="sticky top-0 z-40 backdrop-blur-xl bg-white/85 border-b border-slate-200">
      <div className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between">
        <Link to="/" data-testid="brand-logo" aria-label="SchoolLane – Home"
              className="flex items-center">
          {/* Full logo on md+, book-in-cart mark only on very compact widths */}
          <Logo height={56} className="hidden sm:block" />
          <Logo height={40} mark className="sm:hidden" />
        </Link>
        <nav className="hidden lg:flex items-center gap-7">
          {NAV.map((n) => (
            <Link key={n.to} to={n.to} data-testid={`nav-${n.label.toLowerCase()}`}
              className={`text-sm font-medium transition-colors duration-200 ${pathname === n.to ? "text-brand-blue" : "text-slate-600 hover:text-slate-900"}`}>
              {n.label}
            </Link>
          ))}
        </nav>
        <div className="hidden lg:flex items-center gap-2">
          <Link to="/login" data-testid="nav-login"
                className="text-sm font-semibold px-4 py-2 rounded-md border border-slate-300 text-slate-800 bg-white hover:border-slate-400 hover:bg-slate-50 transition-colors duration-200">
            Log in
          </Link>
          <Link to="/register" data-testid="nav-register" className="text-sm font-semibold px-4 py-2 rounded-md bg-brand-blue text-white hover:bg-brand-blueDark transition-colors duration-200">
            Get Started
          </Link>
        </div>
        <button className="lg:hidden" data-testid="nav-toggle" onClick={() => setOpen(!open)}>
          {open ? <X /> : <Menu />}
        </button>
      </div>
      {open && (
        <div className="lg:hidden border-t border-slate-200 bg-white">
          <div className="px-6 py-4 flex flex-col gap-3">
            {NAV.map((n) => (
              <Link key={n.to} to={n.to} onClick={() => setOpen(false)} className="text-slate-700 py-1">{n.label}</Link>
            ))}
            <Link to="/login" onClick={() => setOpen(false)}
              className="text-slate-800 border border-slate-300 rounded-md px-4 py-2 text-center font-semibold">
              Log in
            </Link>
            <Link to="/register" onClick={() => setOpen(false)} className="text-white bg-brand-blue rounded-md px-4 py-2 text-center">Get Started</Link>
          </div>
        </div>
      )}
    </header>
  );
}
